var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.groupedTimeEntries, function(group, index) {
      return _c(
        "div",
        { key: index },
        [
          _c("list-group", {
            attrs: {
              date: group.group,
              "time-entries": group.values,
              showUser: _vm.showUser
            }
          })
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }